"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isNil = function isNil(obj) {
  return obj === undefined || obj === null || typeof obj === 'undefined';
};

var _default = isNil;
exports["default"] = _default;